import { all } from "redux-saga/effects";
import { combineReducers } from "redux";
import * as auth from "../app/redux/authRedux";
import { accountSlice, appSlice, appsSlice, categoriesSlice, searchSlice, settingsSlice } from "../app/redux/commonSlice";

export const rootReducer = combineReducers({
  auth: auth.reducer,
  account: accountSlice.reducer,
  apps: appsSlice.reducer,
  app: appSlice.reducer,
  categories: categoriesSlice.reducer,
  settings: settingsSlice.reducer,
  search: searchSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
